import Container from './Container'

export default Container.withComponent('form')



// WEBPACK FOOTER //
// ./src/primitives/Form.js